module.exports = __webpack_public_path__ + "static/media/160371644481279hiraans.2f42fbb8.png";